/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component, Fragment } from 'react'

const { subString, rxaget, timeConverter, rxChangeSlug, stringToColour, idToColor, formatBytes, secondToTime, rxconfig ,changeColorSVG} = global.rootRequire('classes/ulti')
const { checkAvatarSender, checkIsOwner, checkName, checkNameUser, checkNameContact, changeColorAva, textAva } = global.rootRequire('classes/chat')

let zget = global.rxu.get

class GroupPopupItem extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {

    }
    this.currentGroup = {}
    this.lastSeenMessId = ''
    this.urllinkId = ''
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   console.log("??akakakakakaka")

  // }
  checkEleContactTitle(index){
    let ele = this.props.groupsNChat[index]
    let elePre = this.props.groupsNChat[index-1]
    let contactTitle = ''
    let eleContactTitle = rxChangeSlug(checkNameUser(ele, this.userid, this.props.netaauth)).slice(0, 1)
    let elePreContactTitle = rxChangeSlug(checkNameUser(elePre, this.userid, this.props.netaauth)).slice(0, 1)

    if (elePreContactTitle !== eleContactTitle) {
      contactTitle = eleContactTitle
    } else {
      contactTitle = ''
    }
    return contactTitle
  }

  createNewChat(currentGroup){
    this.props.createNewChat(currentGroup)
  }
  render() {
    const userid = this.props.userid
    const index = this.props.index
    const currentGroup = this.props.currentGroup
    this.currentGroup = currentGroup
    const groupsNChat = this.props.groupsNChat
    const groupsNChatChecked = this.props.groupsNChatChecked
    const flagCreateGroupPopup = this.props.flagCreateGroupPopup
    const typePopup = this.props.typePopup
    console.log('Render group Item 123')
    return (
      <div>
      {   
        currentGroup.id !== userid && (<div key={index}>
            {this.checkEleContactTitle(index).length !== 0 &&<div className='zcontact_title'>{this.checkEleContactTitle(index)}</div>}
            <div onClick={e => { this.createNewChat(currentGroup) }} className='group_contacts_item clearfix' >
              <div className='zgroup_avatar'>
                {currentGroup.profile_url && (
                  <img src={global.rxu.config.cdn_endpoint + currentGroup.profile_url} alt=''
                    data-id={'userava' + currentGroup.id} className='ava-useravatar images-static'
                    onError={e => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}
                  />
                )}
                {!currentGroup.profile_url && <span className='ava-span' style={{ background: `${changeColorAva(rxaget(currentGroup, 'group_id', ''))}` }} >
                  {textAva(rxChangeSlug(checkNameUser(currentGroup)))}
                </span>}
              </div>
              <div className='zgroup_maininfo-contact'>
                <div className='newgroup_userinfo_place'> {subString(checkNameUser(currentGroup), 20)} </div>
                {(flagCreateGroupPopup || (['add_member', 'leave_group'].indexOf(typePopup) !== -1)) &&
                  <div className='newgroup_checked'>
                    <label className='container100'>
                      <input className='checkmark1' type='checkbox' checked={groupsNChatChecked.indexOf(currentGroup.id) !== -1} onChange={e => this.createNewChat(currentGroup)} />
                      <span className='checkmark'></span>
                    </label>
                  </div>
                }
              </div>
              <div className='newgroup_divider'></div>
              
            </div>
          </div>
        )
      }
      </div>
    )
  }
}

export default GroupPopupItem